<script setup lang="ts">
import { computed } from 'vue';
import { cn } from '../../design-system/utils';

interface Props {
  variant?: 'default' | 'elevated' | 'outlined' | 'subtle';
  padding?: 'none' | 'sm' | 'md' | 'lg';
  interactive?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'default',
  padding: 'md',
  interactive: false,
});

const variantClasses = {
  default: 'bg-card border border-border',
  elevated: 'bg-elevated border border-border-subtle shadow-md',
  outlined: 'bg-transparent border border-border',
  subtle: 'bg-bg-muted border border-transparent',
};

const paddingClasses = {
  none: 'p-0',
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8',
};

const classes = computed(() =>
  cn(
    'rounded-lg',
    variantClasses[props.variant],
    paddingClasses[props.padding],
    props.interactive &&
      'transition-shadow duration-fast cursor-pointer hover:shadow-md focus-visible:outline-none focus-visible:shadow-focus',
  ),
);
</script>

<template>
  <div :class="classes" :tabindex="interactive ? 0 : undefined">
    <slot />
  </div>
</template>
